import React from 'react';
import './PrePrimaryIntro.css';
import { Link } from 'react-router-dom';

const PrePrimaryIntro = () => {
  return (
    <div className="ppi-container">
      <div className="ppi-badge">✨ Pre-Primary Olympiad 2026 ✨</div>
      
      <div className="ppi-content">
        <h1 className="ppi-title">
          Unleash Your Child's <span className="ppi-highlight">Potential</span>
        </h1>
        
        <p className="ppi-description">
          Give your little one a platform to shine! Our Pre-Primary Olympiad is specially 
          designed for young minds to explore, learn, and excel in a friendly competitive environment.
        </p>

        <div className="ppi-features">
          <div className="ppi-feature">
            <span className="ppi-feature-icon">🎯</span>
            <div>
              <h4 className="ppi-feature-heading">Age Group</h4>
              <p className="ppi-feature-text">3-6 Years (Nursery to UKG)</p>
            </div>
          </div>
          
          <div className="ppi-feature">
            <span className="ppi-feature-icon">📚</span>
            <div>
              <h4 className="ppi-feature-heading">Subjects Covered</h4>
              <p className="ppi-feature-text">English, Mathematics, General Awareness</p>
            </div>
          </div>
          
          <div className="ppi-feature">
            <span className="ppi-feature-icon">⏰</span>
            <div>
              <h4 className="ppi-feature-heading">Exam Duration</h4>
              <p className="ppi-feature-text">45 Minutes</p>
            </div>
          </div>
          
          <div className="ppi-feature">
            <span className="ppi-feature-icon">📝</span>
            <div>
              <h4 className="ppi-feature-heading">Question Type</h4>
              <p className="ppi-feature-text">Picture-Based, Interactive Questions</p>
            </div>
          </div>
        </div>

        <div className="ppi-price-section">
          <div className="ppi-price-card">
            <span className="ppi-price-label">Registration Fee</span>
            <div className="ppi-price-value">
              ₹250 <span className="ppi-price-old">₹999</span>
            </div>
            <span className="ppi-price-note">One-time fee • No hidden charges</span>
          </div>
          
          <div className="ppi-included-card">
            <h4 className="ppi-included-title">What's Included?</h4>
            <ul className="ppi-included-list">
              <li>✅ Free Practice Book</li>
              <li>✅ Participation Certificate</li>
              <li>✅ Medal for Ranked Students</li>
              <li>✅ Trophy for Top Performers</li>
            </ul>
          </div>
        </div>

        <Link to='/knowmorePre'><button className="ppi-knowmore-btn">
          Know More About Olympiad
          <span className="ppi-btn-arrow">→</span>
        </button></Link>
      </div>

      <div className="ppi-decoration">
        <div className="ppi-circle1"></div>
        <div className="ppi-circle2"></div>
        <div className="ppi-circle3"></div>
      </div>
    </div>
  );
};

export default PrePrimaryIntro;